export const SITE_URL = 'https://chatscontrol.com';

// The site serves English at /terms and the other languages at /uk/terms, /ru/terms.
export function legalPageUrl(page, language) {
  const lang = language.split('-')[0];
  return lang === 'en' ? `${SITE_URL}/${page}` : `${SITE_URL}/${lang}/${page}`;
}
